var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: _vm.modalName,
            size: "lg",
            "hide-footer": "",
            title: (_vm.isUpdate ? "Modification" : "Ajout") + " d'une Marque",
          },
        },
        [
          _c(
            "b-form",
            {
              staticClass: "marque-add",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.onSubmit.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("blinki-input-txt", {
                        staticClass: "my-2",
                        attrs: {
                          disabled: _vm.marqueRole,
                          type: "alphabet",
                          id: "nom",
                          label: "nom",
                          placeholder: "Nom marque",
                          module: "marque",
                        },
                        model: {
                          value: _vm.marque.nom,
                          callback: function ($$v) {
                            _vm.$set(_vm.marque, "nom", $$v)
                          },
                          expression: "marque.nom",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("blinki-input-txt", {
                        staticClass: "my-2",
                        attrs: {
                          max: 5000,
                          type: "text",
                          id: "titre",
                          label: "titre",
                          placeholder: "Titre",
                          module: "marque",
                        },
                        model: {
                          value: _vm.marque.titre,
                          callback: function ($$v) {
                            _vm.$set(_vm.marque, "titre", $$v)
                          },
                          expression: "marque.titre",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { sm: "3" } }, [
                    _c("label", { staticClass: "label" }, [_vm._v("Image :")]),
                  ]),
                  _vm._v(" "),
                  _c("b-col", [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("Description"),
                      _c("span", { staticClass: "text-danger m-0" }, [
                        _vm._v("(*)"),
                      ]),
                      _vm._v(" :"),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "3" } },
                    [
                      _c("blinkiUpload", {
                        staticClass: "image-upload",
                        attrs: {
                          "data-images": _vm.images,
                          multiple: false,
                          markIsPrimaryText: "Défini comme principal",
                          primaryText: "Image principale",
                          browseText: "Ajouter une image",
                          dragText: "Glisser l'image ici",
                          dropText: "Déposer l'image",
                          showDelete: false,
                        },
                        on: {
                          "upload-success": _vm.uploadImageSuccess,
                          "before-remove": _vm.beforeRemove,
                          "edit-image": _vm.editImage,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c("b-textarea", {
                        staticClass: "h-100",
                        attrs: { required: "", rows: 8 },
                        model: {
                          value: _vm.marque.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.marque, "description", $$v)
                          },
                          expression: "marque.description",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.marque.delivery_modes
                    ? [
                        _c("b-col", { attrs: { cols: "12" } }, [
                          _c(
                            "div",
                            {
                              staticClass: "w-100 h-100 overflow-auto",
                              staticStyle: { "max-height": "400px" },
                            },
                            _vm._l(_vm.marque.delivery_modes, function (mode) {
                              return _c("livraison-mode", {
                                key: mode.livraison_mode_id,
                                attrs: { mode: mode, "hide-option": true },
                              })
                            }),
                            1
                          ),
                        ]),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c("save-btn-container", {
                staticClass: "mt-2",
                attrs: { modal_name: _vm.modalName, valid: _vm.isFormValid },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }